import { takeLatest, put, take } from 'redux-saga/effects';
import { ACTIONS } from '../actions/actionTypes';
import {newMessage} from '../views/InteractionViews/interactions';
import { push } from 'react-router-redux';
import * as game from '../controllers';
import errorCatcher from '../utils/errorCatcher';

export function * DISPATCH_OPENNOTIFICATION () {
    try {
        yield takeLatest(ACTIONS.NOTIFICATION_OPEN, function * (action) {
            let status = {'seen': new Date()};
            let {notification} = action.payload;
            if (!notification.seen) {
                game.notifications.updateNotification(notification._id, status).catch(e => {
                    console.warn('Error setting notification as received', e);
                });
            }
            let interaction = newMessage({title: action.payload.title, content: action.payload.content, type: action.payload.type, from: action.payload.from});
            console.log('interaction', interaction);
            yield put({
                type: ACTIONS.DISPATCH_INTERACTION,
                payload: interaction
            });
            yield take(ACTIONS.INTERACTION_ACTION);
            yield put(push('/notifications'));
        });
    } catch (error) {
        errorCatcher('Error in DISPATCH_OPENNOTIFICATION (gameSaga)', error);
    }
}



// WEBPACK FOOTER //
// ./src/sagas/notificationSaga.js